/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Column, Row, SmallMessage } from "components/styles";
import {
	Container, Description,
	DividerTitle, Subtitle, Title,
} from "views/components/AttendanceList/TakeTeacherAttendancePanel/styles";
//#endregion
//#region Components
//#endregion
//#region Images
import pinIcon from "img/pin_icon.svg";
import attendedIcon from "img/attended_icon.svg";
//#endregion
//#region Services
import { currentUserLocalStorage } from "services/storage/general";
import CustomButton from "components/CustomButton/CustomButton";
import { requestGetServerTime } from "services/general";
import {
	DAY_IN_MILLIS,
	getTodayWithoutHourInMillis,
} from "components/CustomDatePicker/utils/helpers";
import { getMinutesOfToday } from "components/CustomTimePicker/utils";
import { CUSTOM_BUTTON_PROPS } from "views/components/AttendanceList/TakeTeacherAttendancePanel/constants";
//#endregion
//#region Utils
//#endregion

const TakeTutorAttendancePanel = ({
	loadingRequest,
	checkInTime,
	checkOutTime,
	classTime,
	showDialogCheckTime,
	setServerTime,
	checkIfAttendanceWasTaken,
	dateTime,
}) => {
	const [tutorName, setTutorName] = useState("");
	const [mustDisabledCheckTimeButton, setMustDisabledCheckTimeButton] =
		useState(false);
	const [finalized, setFinalized] = useState(false);
	useEffect(() => {
		const currentUser = currentUserLocalStorage.get();
		if (!currentUser) return;
		setTutorName(currentUser.name);
	}, []);
	useEffect(() => {
		fillMustDisabledToCheckTimeButton();
		const intervalId = setInterval(() => {
			fillMustDisabledToCheckTimeButton();
		}, 1000);
		return () => clearInterval(intervalId);
	}, []);
	const confirmTakeAttendance = async checkTimeKey => {
		if (checkTimeKey === "checkOut" && !checkIfAttendanceWasTaken()) return;
		loadingRequest.show();
		const serverTime = await requestGetServerTime();
		setServerTime(serverTime);
		loadingRequest.hide();
		showDialogCheckTime[checkTimeKey].set(true);
	};
	const fillMustDisabledToCheckTimeButton = () => {
		const { date, time } = dateTime;
		const today = getTodayWithoutHourInMillis();
		const nowTime = getMinutesOfToday();
		const maxDate = date + 2 * DAY_IN_MILLIS;
		const minTimeInDate = time.start - 15;
		const value =
			today < date ||
			// Máximo 2 días de la fecha
			today > maxDate ||
			// Mínimo 15 minutos antes de la hora en la fecha
			(today === date && nowTime < minTimeInDate);
		setMustDisabledCheckTimeButton(value);
		setFinalized(today > maxDate);
	};
	return checkInTime && checkOutTime && classTime ? (
		<Container
			direction="column"
			align="flex-start"
		>
			<Subtitle>Detalle de clase</Subtitle>
			<Row>
				<img
					src={attendedIcon}
					alt="Ícono de asistió"
				/>
				<Row columnGap="25px">
					<Title>
						Tu hora de entrada: <strong>{checkInTime}</strong>
					</Title>
					<DividerTitle>|</DividerTitle>
					<Title>
						Tu hora de salida: <strong>{checkOutTime}</strong>
					</Title>
					<DividerTitle>|</DividerTitle>
					<Title>
						Tiempo de clase: <strong>{classTime}</strong>
					</Title>
				</Row>
			</Row>
		</Container>
	) : (
		<Container
			direction="row"
			align="center"
		>
			<Column
				gap="8px"
				grow="1"
				width="max-content"
			>
				{!checkInTime && !checkOutTime ? (
					<Title weight="bold">{tutorName}</Title>
				) : (
					<Row gap="15px">
						<Title>
							Hora de entrada: <strong>{checkInTime}</strong>
						</Title>
						<DividerTitle>|</DividerTitle>
						<Title>
							Hora de salida:{" "}
							<strong>{checkOutTime || "-"}</strong>
						</Title>
					</Row>
				)}
				<Row>
					<img
						src={pinIcon}
						alt="Ícono de fijamiento"
					/>
					<Description>
						{!checkInTime && !checkOutTime
							? "No olvides que debes marcar tu entrada y tu salida al finalizar la clase."
							: "Toma la asistencia de los estudiantes para poder marcar tu salida."}
					</Description>
				</Row>
			</Column>
			<Column
				minWidth="unset"
				width="max-width"
				align="center"
				gap="5px"
			>
				{!checkInTime && (
					<CustomButton
						{...CUSTOM_BUTTON_PROPS}
						text="Marcar entrada"
						onClick={() => confirmTakeAttendance("checkIn")}
						disabled={mustDisabledCheckTimeButton}
					/>
				)}
				{checkInTime && (
					<CustomButton
						{...CUSTOM_BUTTON_PROPS}
						text="Marcar salida"
						onClick={() => confirmTakeAttendance("checkOut")}
						disabled={
							(checkInTime && checkOutTime) ||
							mustDisabledCheckTimeButton
						}
					/>
				)}
				{finalized && <SmallMessage>Refuerzo finalizado</SmallMessage>}
			</Column>
		</Container>
	);
};

export default TakeTutorAttendancePanel;
